import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { useMatch, Link } from 'react-router-dom';
import { Spinner, useLocalizeMessage } from 'libs.nucleus';
import { PageHeader, PageWrapper, SectionCard } from 'libs.react';
import { ResponseDetailView } from '../../components/response_detail_view';
import ActivityResponseTitle from '../../components/visit_activity_responses/activity_response_title.component';
import { getParticipantNumber } from '../../helpers/participants.helpers';
import { getVisitActivityResponsesData } from '../../helpers/visit.helpers';
import { useAxonAccountContext } from '../../hooks/use_axon_account_context';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
import { useSiteContext } from '../../hooks/use_site_context';
export const ParticipantResponseDetailPage = () => {
    const translate = useLocalizeMessage();
    const { environment } = useCurrentEnvironment();
    const site = useSiteContext();
    const account = useAxonAccountContext();
    const match = useMatch('/site/study/:studyId/participants/:participantId/response/:responseId');
    const participantId = match?.params.participantId;
    const responseId = match?.params.responseId;
    const studyId = match?.params.studyId;
    // Get detailed response data with step responses in a single query
    const { data: responseData, isLoading } = useQuery({
        queryKey: ['participantResponseDetail', account._id, site?._id, participantId, responseId],
        queryFn: async () => {
            if (!environment || !site || !participantId || !responseId) {
                return null;
            }
            const response = await getVisitActivityResponsesData({
                environment,
                participantId,
                accountId: account._id,
                siteId: site._id,
                responseId,
            });
            const allDetailedResponses = response?.data?.data || [];
            return allDetailedResponses[0] || null;
        },
        enabled: !!environment && !!account._id && !!site?._id && !!participantId && !!responseId,
    });
    if (isLoading) {
        return (_jsx(PageWrapper, { children: _jsx(Spinner, { wrapper: 'full' }) }));
    }
    if (!responseData) {
        const breadcrumbsPages = [
            { name: translate('generic.participants'), path: `/site/study/${studyId}/participants` },
            { name: translate('generic.responses'), path: '' },
        ];
        return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { breadcrumbPages: breadcrumbsPages, title: '', LinkComponent: Link }), _jsx(SectionCard, { children: _jsx("section", { className: 'flex flex-col items-center justify-center p-10 m-10', children: _jsx("p", { className: 'text-md text-secondary', children: translate('info.participant_responses.empty') }) }) })] }));
    }
    const breadcrumbsPages = [
        { name: translate('generic.participants'), path: `/site/study/${studyId}/participants` },
        {
            name: getParticipantNumber(responseData.c_public_user),
            path: `/site/study/${studyId}/participants/${participantId}#responses`,
        },
        { name: responseData.c_task.c_name, path: '' },
    ];
    return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { breadcrumbPages: breadcrumbsPages, title: _jsx(ActivityResponseTitle, { response: responseData }), LinkComponent: Link }), _jsx(ResponseDetailView, { response: responseData })] }));
};
